// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SimilarStrollers__headline":"xn_a bht_vp bht_vh bht_xe bht_rg bht_tr bht_qx"};